<template>
    <tr class="c-table__row">
        <td class="c-table__cell">
            {{ phoneNumber.phone_number }}
            <span v-if="phoneNumber.locality && phoneNumber.region" class="u-block u-text-mute u-text-xsmall">
                {{ phoneNumber.locality }}, {{ phoneNumber.region }}
            </span>
        </td>

        <td class="c-table__cell center hidden-xs">
            <span class="u-block center">{{ phoneNumber.friendly_name }}</span>
        </td>

        <td class="c-table__cell center hidden-xs">
            <span class="u-block center">{{ phoneNumber.iso_country || '-' }}</span>
        </td>

        <!-- <td class="c-table__cell center hidden-xs">
            <span class="u-block center">{{ phoneNumber.forward_voice_to }}</span>
        </td> -->

        <td v-if="isImpersonatingOrDeveloper" class="c-table__cell center">
            <dropdown-actions label="Actions" :updateEvent="'phone_numbersPending-'+phoneNumber.id">
                <!--
                <dropdown-action-item :route="'#/show/' + phoneNumber.id" event="phone_numbersShow" :payload="phoneNumber.id">View</dropdown-action-item>
                -->

                <dropdown-action-item :route="'#/edit/' + phoneNumber.id" event="phone_numbersEdit" :payload="phoneNumber.id">Edit</dropdown-action-item>

                <dropdown-action-item event="phone_numbersDelete" :payload="phoneNumber.id"
                                      message="Are you sure? This phone number will be released and any associated messaging configurations will be deactivated. There is no undo.">
                    Delete
                </dropdown-action-item>
            </dropdown-actions>
        </td>
    </tr>
</template>

<script>
import DropdownActionItem from '~/components/general/DropDownActionItem.vue';
import DropdownActions from '~/components/general/DropDownActions.vue';

export default {
    props: ['phoneNumber'],
    components: {
        DropdownActionItem,
        DropdownActions
    },
    computed: {
        isImpersonatingOrDeveloper() {
            return Spark.isImpersonating || Spark.isDeveloper;
        },
    },
};
</script>
